import { OriginatorStatus, TemplateType } from '@shared/generated/graphql';
import { Order } from '@shared/types/order';
import { isNil } from 'lodash';

export function isHeldInTmsSandbox(order: Order): boolean {
  const { originator } = order;
  if (isNil(originator.id) || originator.status !== OriginatorStatus.TEST) {
    return false;
  }

  const freightOrderConfig =
    order.organization.integrationConfigs.integrations.find(
      (config) => config.orderType === TemplateType.FREIGHT_ORDER
    );
  if (isNil(freightOrderConfig)) return false;

  const override = originator.configOverrides?.integrations?.find(
    (o) =>
      o.orderType === undefined || o.orderType === TemplateType.FREIGHT_ORDER
  );
  const sendAsProduction =
    override?.sendAsProduction !== undefined
      ? override.sendAsProduction
      : freightOrderConfig.sendAsProduction;
  return sendAsProduction === true;
}
